import { BaseConfig } from '../ServiceConfig';

export interface SellerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.SellerServiceConfigData';
  url: string;
}

export const SellerConfigurationFields: (keyof SellerConfiguration)[] = ['url'];

export const BlankSellerConfiguration: SellerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.SellerServiceConfigData',
} as SellerConfiguration;
